import { render, staticRenderFns } from "./SortedAllergenRow.vue?vue&type=template&id=809aa47c&scoped=true&"
import script from "./SortedAllergenRow.vue?vue&type=script&lang=ts&"
export * from "./SortedAllergenRow.vue?vue&type=script&lang=ts&"
import style0 from "./SortedAllergenRow.vue?vue&type=style&index=0&id=809aa47c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "809aa47c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
